import React, { useState, useEffect, useContext } from 'react';

import * as net from "../../../lib/net";
import Fr_Input from "../../../lib/ui/fr_input";
import Wnd_Error from "../../../lib/ui/wnd_error";
import Wnd_Ok from "../../../lib/ui/wnd_ok";

class Step_open extends React.Component {
  constructor(props, context) {
    super(props);

    this.pos = props.store.pos;

    this.state = {};
    this.state.ynq = [];

    this.state.cols = {};
    this.state.lrwrk = false;
    this.state.mno = {};
    this.state.mno = props.wnds.mno;
    this.state.msg = {};
  }
  componentDidUpdate() {
  }
  componentWillUnmount() {
  }
  componentDidMount() {
  }

    dlg_style() {
      var css = {};
      //css.width = window.innerWidth * 0.8;
      //css.height = window.innerHeight * 0.8;
      return css;
    }
    tab_style(tabid) {
      var css = {};
      css.display = "none";
      if(this.state.tabval === tabid) css.display = "block";
      return css;
    }
    tab_head(tabid) {
      var css = {};
      css.background = "#fff";
      css.color = "#000";
      if(this.state.tabval === tabid) {
          css.background = "#080";
          css.color = "#fff";
      }
      return css;
    }
    grp_style(row) {
      var css = {};
      css.background = "#008";
      if(this.state.gnr === row.vgrupp) css.background = "#080";
      return css;
    }

    formchange (e) {
      const name = e.target.name;
      const value = e.target.value;
      var pbo = this.state.pbo;
      var na = name.split(".");
      pbo[na[0]][na[1]] = value;
      this.setState({pbo: pbo});
      //setState({[name]: value});
    }

    handleUserInput (e) {
      const name = e.target.name;
      const value = e.target.value;
      var user = this.state.user;
      user[name] = value;
      this.setState({user: user});
      //setState({[name]: value});
    }
    wnd_close = () => {
		//this.props.ctx.setState({ wnds: {} });
		this.props.ctx.upd(this.props.ctx);
	};
    handleChange = (event, newValue) => {
        //alert(newValue);
        this.setState({ix: newValue});
      };
    toggle() {
      this.setState({modal: false});
	};

  submitHandler = event => {
    event.preventDefault();
    event.target.className += " was-validated";
  };

  changeHandler = event => {
    this.setState({ [event.target.name]: event.target.value });
  };

  tb_style() {
      var css = {};
      css.height = window.innerHeight - 275;
      return css;
  }
  cssCols (cid) {
      var css = {};
      if(this.state.cols[cid]) css.width = this.state.cols[cid].toString() + "px";
      //if(cid == "c01") alert(JSON.stringify(this.state.cols[cid]));
      return css;
  }
  syncCols (tb) {

    if (!document.getElementById(tb)) return;

    var cols = {};
    var ix = document.getElementById(tb).rows.length - 1;
    var ic = document.getElementById(tb).rows[0].cells.length;
    var ci = 0;
    while(ci < ic) {
        var cxi = ci + 1;
        var col = "c" + cxi.toString().padStart(2, "0");
        cols[col] = document.getElementById(tb).rows[ix].cells[ci].clientWidth + 1;
        ci = ci + 1;
    }
    this.setState({cols: cols });
    //alert(JSON.stringify(this.state.cols));
    //this.forceUpdate();
  };
  val_save (name, e) {
    //alert(JSON.stringify(name));
    //alert(JSON.stringify(value));
    e.preventDefault();
    const value = e.target.value;
     var mno = this.state.mno;
      //var na = name.split(".");
      //pbo[na[0]][na[1]] = value;
      mno[name] = value;
      this.setState({mno: mno});
      //setState({[name]: value});
    }

  menu_save() {
    var self = this;
    var prm = {};
    prm.req = "pos.pos_plumenu.plumenu_upd";
    prm.plm00 = this.state.mno;

    net.sio_req(prm)
    .then(function(ret){
        //alert(JSON.stringify(ret));
   		//self.props.ctx.upd(self.props.ctx);
        var msg = { info: false, ok: true, text: "Sparad ..."};
        self.setState({msg: msg });
        setTimeout(function(){
            self.setState({msg: {} });
        }, 1000);
  })
    .catch(function(e){
        var txt = JSON.stringify(e);
    });
  }
  menu_del() {
    var self = this;

    var prm = {};
    prm.req = "pos.pos_plumenu.plumenu_del";
    prm.plm00 = this.state.mno;

    net.sio_req(prm)
    .then(function(ret){
        //alert(JSON.stringify(ret.rca));
   		self.props.ctx.upd(self.props.ctx);
    })
    .catch(function(e){
        var txt = JSON.stringify(e);
    });
  }

  render() {
    //if(!this.props.show) return "";

    //alert(this.props.ctx.state.lro);

    var title = this.props.title;
    if(!title) title = "Knappar";
    //if(props.kro) alert(props.kro.krr00.kid);

	var html =
        <div className="mx_base">
        <div className="m2_backdrop" />
        <div className="m2_dlg mx_70 flex-col" style={ this.dlg_style() } draggable="true" >
        <div className="mx_content flex">

            <div className="flex-row" style={{padding:"5px",height:"35px"}}>
                    <div className="flex-col flex">
                        <div>MENY:</div>
                    </div>
                    <div className="flex-col">
                        <div>UPPDATERA</div>
                    </div>
            </div>
            <div className="divider_orange"></div>

            <div className="flex-row">
            <div className="col flex">
              <label className="">Avd</label>
              <input value={this.state.mno.avd} onChange={(e)=> this.val_save("avd", e) }
                     type="text" className="form-control w150"
                     placeholder="" required
              />
            </div>
            </div>
            <div className="flex-row">
            <div className="col flex">
              <label className="">MENY PLU</label>
              <input value={this.state.mno.plunr} onChange={(e)=> this.val_save("plunr", e) }
                     type="text" className="form-control w250"
                     placeholder="" required
              />
            </div>
            </div>
            <div className="flex-row">
                <div className="col flex">
              <label className="">KOPPLAD PLU</label>
              <input value={this.state.mno.plunrdel} onChange={(e)=> this.val_save("plunrdel", e) }
                     type="text" className="form-control w250"
                     placeholder="" required
              />
            </div>
            </div>

        </div>
        <div className="mx_foot flex-row flex-space-between">
            <button className="btn btn-hw-red w250" onClick={() => this.wnd_close() } >
                STÄNG
            </button>
            <button className="btn btn-hw-orange w250" onClick={() => this.menu_del() } >
                TA BORT
            </button>
            <button className="btn btn-hw-green w250" onClick={() => this.menu_save() } >
                SPARA
            </button>
        </div>
      </div>
        <Wnd_Error msg={this.state.msg} ctx={this} />
        <Wnd_Ok msg={this.state.msg} ctx={this} />
      </div>
	;
	return html;
  };
}

export default Step_open;